<template>
	<div class="relative flex flex-col items-center justify-center gap-[10px]" ref="mainEl">
		<div class="relative w-[90%]">
			<div class="will-change-transform">
				<video @click="togglePlay()" ref="videoEl" class="absolute top-0 z-[1]" @ended="reset()" preload="none">
					<source type="video/mp4" />
					Your browser does not support HTML video.
				</video>
			</div>
			<img alt="" class="relative center top-0 bottom-0 pointer-events-none will-change-transform z-[2] w-full" :src="poster" ref="posterEl" />
			<img alt="" class="absolute center top-0 bottom-0 pointer-events-none will-change-transform z-[3]" src="images/1x_images/btn-play.png" srcset="images/2x_images/btn-play.png 2x" ref="playBtnEl" v-if="playing == false" />
		</div>
		<div class="video-bar relative w-[90%] h-fit py-[20px]" @touchstart="handleTouchStart" @touchmove="handleTouchMove" @touchend="handleTouchEnd">
			<!-- <div class="relative w-[90%] h-fit py-[20px]"> -->
			<div class="relative bg-[#cbd6e9] rounded-[15px] p-[10px]">
				<div class="relative w-full h-[10px] rounded-[10px] overflow-hidden" ref="barParentEl">
					<div class="relative bg-[#c2ad6c] w-full h-full" ref="yellowBarEl" :style="{ left: `-${barLength}px` }"></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
/* eslint-disable */
import gsap from "gsap";
import { NativeAudio } from "@capgo/native-audio";

export default {
	name: "video-comp",
	props: {
		url: 0,
		poster: "",
	},
	data() {
		return {
			playing: false,
			duration: 0,
			remainingDur: 0,
			barLength: 0,
			barOffsetLeft: 0,
			barOffsetRight: 0,
			drag: false,
			tween: null,
		};
	},
	methods: {
		handleTouchStart(e) {
			this.drag = true;
			this.getPosition(e);
		},
		handleTouchMove(e) {
			if (this.drag == true) {
				this.getPosition(e);
			}
		},
		handleTouchEnd(e) {
			this.drag = false;
			if (this.playing == true) {
				this.playVideo();
			}
		},
		getPosition(e) {
			// console.log(e);
			this.killRunning();

			var progress;
			var touchX = e.touches[0].clientX / ratioToOriginal;
			var barX;

			if (touchX > this.barOffsetRight) {
				barX = this.barLength;
				progress = 1;
			} else if (touchX < this.barOffsetLeft) {
				barX = 0;
				progress = 0;
			} else {
				barX = touchX - this.barOffsetLeft;
				progress = barX / this.barLength;
			}

			this.$refs.videoEl.pause();
			this.$refs.videoEl.currentTime = progress * this.duration;
			gsap.set(this.$refs.yellowBarEl, { x: barX, overwrite: true });
		},
		animateBar() {
			this.remainingDur = this.duration - this.$refs.videoEl.currentTime;
			this.tween = gsap.to(this.$refs.yellowBarEl, { x: this.barLength, duration: this.remainingDur, ease: "none", overwrite: true });
		},
		togglePlay() {
			if (this.playing == false) {
				this.playVideo();
			} else {
				this.pauseVideo();
			}
		},
		playVideo() {
			if (window.bgAudio) {
				// prettier-ignore
				gsap.to(window.bgVolume, { overwrite: true, vol: 0, duration: 1.0, onUpdate: (e) => {
					NativeAudio.setVolume({
						assetId: 'bgMusic',
						volume: window.bgVolume.vol
					})
				}})
				audioBtnTween.pause();
			}

			gsap.set(this.$refs.posterEl, { autoAlpha: 0 });
			this.playing = true;
			this.$refs.videoEl.play().catch((e) => console.log(e));
			this.animateBar();
		},
		pauseVideo() {
			if (window.bgAudio) {
				// prettier-ignore
				gsap.to(window.bgVolume, { overwrite: true, vol: 0.3, duration: 1.0, onUpdate: (e) => {
					NativeAudio.setVolume({
						assetId: 'bgMusic',
						volume: window.bgVolume.vol
					})
				}})
				audioBtnTween.resume();
			}

			// gsap.to(this.$bgMusic, { volume: 1, ease: "none", duration: 0.5, overwrite: true });
			this.playing = false;
			this.$refs.videoEl.pause();
			this.killRunning();
		},
		jumpTo(progress) {
			this.$refs.videoEl.currentTime = progress * this.duration;
			gsap.set(this.$refs.yellowBarEl, { x: progress * this.barLength, overwrite: true });
			// if (this.playing) this.animateBar();
			this.playVideo();
		},
		killRunning() {
			if (this.tween) {
				this.tween.kill();
			}
		},
		start() {
			if (!this.$refs.videoEl.src) {
				this.initVideo();
			}
			this.$nextTick(() => {
				const bar = this.$refs.barParentEl.getBoundingClientRect();
				const page = this.$refs.mainEl.getBoundingClientRect();
				this.barLength = bar.width / ratioToOriginal;
				this.barOffsetLeft = (bar.left - page.left) / ratioToOriginal;
				this.barOffsetRight = (bar.right - page.left) / ratioToOriginal;
			});
		},
		reset() {
			this.pauseVideo();
			this.resetValues();
		},
		resetValues() {
			this.$refs.videoEl.currentTime = 0;
			this.remainingDur = this.duration;
			gsap.set(this.$refs.yellowBarEl, { x: 0, overwrite: true });
			gsap.set(this.$refs.posterEl, { autoAlpha: 1 });
		},
		initVideo() {
			const video = this.$refs.videoEl;
			video.src = this.url;
			video.load();
			// prettier-ignore
			video.addEventListener("loadeddata", () => {
				this.duration = video.duration;
				this.resetValues();
			}, { once: true });
		},
	},
	mounted() {},
};
</script>

<style scoped>
video {
	width: 100%;
}
</style>
